module.exports = __webpack_public_path__ + "static/nandy-7e56f3dfb6e05f33c763c85e6903b175.jpg";